import React, { useEffect, useState } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import api from "../api/axios";

const DownloadPage = () => {
  const [files, setFiles] = useState([]);

  const fetchFiles = async () => {
    const res = await api.get("companyblog/downloads/");
    setFiles(res.data);
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  // 🔥 FORCE DOWNLOAD HANDLER
  const handleDownload = async (fileUrl, filename) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Failed to download file");
      console.error(error);
    }
  };

  return (
    <>
      <Navbar />

      {/* PAGE CSS */}
      <style>
        {`
        .download-container {
          max-width: 1200px;
          margin: 40px auto;
          padding: 20px;
        }

        .download-card {
          background: #fff;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
        }

        .download-header {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .download-table {
          width: 100%;
          border-collapse: collapse;
        }

        .download-table th {
          text-align: left;
          padding: 12px;
          border-bottom: 2px solid #ddd;
        }

        .download-table td {
          padding: 12px;
          border-bottom: 1px solid #eee;
        }

        .download-table tr:hover {
          background: #fafafa;
        }

        .download-link {
          color: #2d6cff;
          font-weight: 500;
          cursor: pointer;
          text-decoration: none;
        }
        `}
      </style>

      <div className="download-container">
        <div className="download-card">
          <div className="download-header">Downloads</div>

          <table className="download-table">
            <thead>
              <tr>
                <th>Filename</th>
                <th>Type</th>
                <th>File / Link</th>
                <th>Uploaded At</th>
              </tr>
            </thead>

            <tbody>
              {files.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No files available
                  </td>
                </tr>
              ) : (
                files.map((item) => (
                  <tr key={item.id}>
                    <td>{item.filename}</td>
                    <td>{item.file_type.toUpperCase()}</td>
                    <td>
                      {item.file_url ? (
                        <span
                          className="download-link"
                          onClick={() =>
                            handleDownload(item.file_url, item.filename)
                          }
                        >
                          Download
                        </span>
                      ) : (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noreferrer"
                          className="download-link"
                        >
                          Open Link
                        </a>
                      )}
                    </td>
                    <td>
                      {new Date(item.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DownloadPage;
